

const dark = {
  base: "#212121",
  text: "#ecf0f1",
  accent: "orange",
  accent2: "grey",
  color1: "#1c1c1c",
  color2: "white"
}
const light = {
  base: "#ECF0F1",
  text: "#424242",
  accent: "palevioletred",
  accent2: "lightgrey",
  color1: "white",
  color2: "papyawhip"
}
const themes = [
  dark, light
];
export default themes;



// WEBPACK FOOTER //
// ./src/themes.js